import { create } from 'zustand';

let nextId = 1;

export const useToastStore = create((set, get) => ({
  toasts: [],

  addToast: ({ type = 'info', message, duration = 5000 }) => {
    const id = nextId++;
    set((s) => ({ toasts: [...s.toasts, { id, type, message }] }));
    if (duration > 0) {
      setTimeout(() => get().removeToast(id), duration);
    }
    return id;
  },

  removeToast: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));

// Convenience helpers
export const toast = {
  success: (message, opts) => useToastStore.getState().addToast({ type: 'success', message, ...opts }),
  error:   (message, opts) => useToastStore.getState().addToast({ type: 'error', message, ...opts }),
  info:    (message, opts) => useToastStore.getState().addToast({ type: 'info', message, ...opts }),
};
